import { SensorNormalizationStateType } from './state'

export interface SensorNormalizationGettersType {
  getSensorNormalizationById: (state: SensorNormalizationStateType, id: string) => SensorNormalizationStateType['sensorNormalization']
  getSensorNormalizationsBySensorId: (state: SensorNormalizationStateType, sensorId: string) => SensorNormalizationStateType['sensorNormalizations']
  getSensorNormalizationsBySensorSettingId: (state: SensorNormalizationStateType, sensorSettingId: string) => SensorNormalizationStateType['sensorNormalizations']
  getRefreshedNormalizations: (state: SensorNormalizationStateType) => SensorNormalizationStateType['sensorNormalizations']
  getActiveNormalizations: (state: SensorNormalizationStateType) => SensorNormalizationStateType['sensorNormalizations']
}

export const SensorNormalizationGetters = {
  getSensorNormalizationById: (state: SensorNormalizationStateType) => (id: string) => {
    return state.sensorNormalizations.find(sensorNormalization => sensorNormalization.id === id)
  },
  getSensorNormalizationsBySensorId: (state: SensorNormalizationStateType) => (sensorId: string) => {
    return state.sensorNormalizations.filter(sensorNormalization => sensorNormalization.sensorId === sensorId)
  },
  getSensorNormalizationsBySensorSettingId: (state: SensorNormalizationStateType) => (sensorSettingId: string) => {
    return state.sensorNormalizations.filter(sensorNormalization => sensorNormalization.sensorSettingId === sensorSettingId)
  },
  getRefreshedNormalizations: (state: SensorNormalizationStateType) => {
    return state.sensorNormalizations.filter(sensorNormalization => sensorNormalization.refreshed)
  },
  getActiveNormalizations: (state: SensorNormalizationStateType) => {
    const now = new Date()
    return state.sensorNormalizations.filter(sensorNormalization => {
      const initDate = new Date(sensorNormalization.initDate)
      const endDate = new Date(sensorNormalization.endDate)
      return now >= initDate && now <= endDate
    })
  },
}
